import React, {
  FunctionComponent,
} from 'react';
import { Box, Flex, Text } from 'rebass/styled-components';
import {
  InputAdornment, SearchFilter, Select, Input, SearchInputV2,
} from '..';
import { PolicyDebugProp, TimeSeries } from '../../enums';
import {
  PolicyDebugPropOption,
  TimeSeriesOption,
} from '.';
import { useDebuggerState } from '../../hooks';
import { InputShape } from '../v2/input';
import { Button } from '../v2';

export const policyDebugPropOptions: Array<PolicyDebugPropOption> = [
  { value: PolicyDebugProp.CONVERSATION_ID, label: 'Conversation ID' },
  // { value: PolicyDebugProp.AGENT, label: 'Agent' },
  // { value: PolicyDebugProp.ATTRIBUTE, label: 'Attribute' },
  // { value: PolicyDebugProp.POLICY_NAME, label: 'Policy Name' },
  // { value: PolicyDebugProp.SKILL, label: 'Skill' },
];

export const timeSeriesOptions: Array<TimeSeriesOption> = [
  { value: TimeSeries.HOURS_24, label: 'Last 24 hours' },
  { value: TimeSeries.DAYS_7, label: 'Last 7 days' },
];

const PolicySearch: FunctionComponent<{}> = () => {
  const { state, dispatch: setVal, refresh } = useDebuggerState();
  const {
    selectedPolicyDebugPropOption,
    selectedTimeSeriesOption,
    term,
    isLoading,
  } = state;

  const handlePolicyDebugPropChange = (value: PolicyDebugPropOption) : void => {
    setVal({
      selectedPolicyDebugPropOption: value,
    });
  };

  const handleSearchTermChange = (value: string) : void => {
    setVal({
      term: value,
    });
  };

  const handleTimeSeriesChange = (value: TimeSeriesOption) : void => {
    setVal({
      selectedTimeSeriesOption: value,
    });
  };

  const handleRefresh = (): void => {
    refresh();
  };

  return (
    <Flex width="100%" flexWrap="nowrap">
      <Flex flexWrap="nowrap" width={600}>
        <Box width={144}>
          <InputAdornment>
            <Text>Conversation ID</Text>
          </InputAdornment>
          {/* Allowing multiple search filters has been disabled for shipping iteration 1 */}
          {/* <SearchFilter
            value={selectedPolicyDebugPropOption}
            options={policyDebugPropOptions}
            onChange={handlePolicyDebugPropChange}
          /> */}
        </Box>
        <Box flex={1}>
          <SearchInputV2
            value={term}
            placeholder="Enter conversation ID"
            onChange={(ev: any) => {
              const val = ev.target.value;
              handleSearchTermChange(val);
            }}
            onClear={() => {
              handleSearchTermChange('');
            }}
            aria-label="policy-term-search"
            shape={InputShape.SQUARE}
            isLeftAdornment
          />
        </Box>
      </Flex>
      <Box ml={4} width={150}>
        <Select
          value={selectedTimeSeriesOption}
          options={timeSeriesOptions}
          onChange={handleTimeSeriesChange}
          isSearchable={false}
        />
      </Box>
      <Box ml={4} width={150}>
        <Button variant="secondary" onClick={handleRefresh} data-testid="refresh-button" disabled={isLoading}>
          Refresh
        </Button>
      </Box>
    </Flex>
  );
};

export default PolicySearch;
